import { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { ReactComponent as AddSvg } from "@/assets/images/icons/Estates/add.svg";

import classes from "../../maintainers.module.scss";

const TabActiveIngredients = ({ data, setData }) => {
	const { active_ingredients } = useSelector((state) => state.maintainers_products);
	const { addToast } = useToasts();

	const [localActiveIngredients, setLocalActiveIngredients] = useState([]);

	useEffect(() => {
		setLocalActiveIngredients(active_ingredients);
		// eslint-disable-next-line
	}, []);

	const handleConcentrationChange = (index, value) => {
		const updatedIngredients = data.active_ingredients.map((ingredient, idx) => (idx === index ? { ...ingredient, concentration: value } : ingredient));
		setData({ ...data, active_ingredients: updatedIngredients });
	};

	const handleAddRow = () => {
		const newActiveIngredient = {
			value: "",
			label: "",
			concentration: "",
		};

		setData({
			...data,
			active_ingredients: [...data.active_ingredients, newActiveIngredient],
		});
	};

	const handleRemoveRow = (index) => {
		const updateActiveIngredients = data.active_ingredients.filter((_, idx) => idx !== index);
		setData({ ...data, active_ingredients: updateActiveIngredients });
		addToast("Ingrediente activo eliminado. Los cambios se aplicaran al momento de guardar.", {
			appearance: "info",
		});
	};

	return (
		<Row className={`${classes.row_form} ${classes.list}`} style={{ marginTop: "10px" }}>
			<div>
				<div className={classes.button} onClick={handleAddRow}>
					<AddSvg className={classes.icon} />
					Nuevo Ingrediente Activo
				</div>
			</div>

			<table className={classes.table}>
				<thead className={classes.thead}>
					<tr>
						<td>Ingrediente activo</td>
						<td colSpan={2}>Concentración</td>
					</tr>
				</thead>
				<tbody>
					{data.active_ingredients &&
						data.active_ingredients.map((ingredient, index) => (
							<tr key={index}>
								<td>
									<CreatableSelect
										value={localActiveIngredients.find((localIngredient) => localIngredient.value === ingredient.value) || null}
										onChange={(opt, meta) => {
											if (meta.action === "create-option") {
												let newOption = {
													value: meta.option.value,
													label: meta.option.value,
												};

												setLocalActiveIngredients([...localActiveIngredients, newOption]);
											}

											const updatedIngredients = data.active_ingredients.map((ing, idx) =>
												idx === index ? { ...ing, value: opt.value, label: opt.label } : ing,
											);
											setData({ ...data, active_ingredients: updatedIngredients });
										}}
										placeholder="Seleccione"
										options={localActiveIngredients}
										components={{ NoOptionsMessage }}
										formatCreateLabel={(value) => `Crear ${value}`}
									/>
								</td>
								<td>
									<Form.Control
										placeholder="Concentración"
										value={ingredient.concentration || ""}
										onChange={(e) => handleConcentrationChange(index, e.target.value)}
									/>
								</td>
								<td className="d-flex align-items-center justify-content-center">
									<RemoveSvg
										className={`${classes.icon_flags} cursor-pointer`}
										onClick={() => {
											handleRemoveRow(index);
										}}
										title="Eliminar"
									/>
								</td>
							</tr>
						))}
				</tbody>
			</table>
		</Row>
	);
};

export default TabActiveIngredients;
